<template>
  <div class="speechAnalysis TopHeadder">
      <!-- 语音分析 -->
      <div class="bannerBox">
          <img src="../../assets/image/banner-speechAnalysis.jpg" />
      </div>

      <div class="PublicPadding">
          <h4 class="title">功能介绍</h4>
          <div class="PublicUl">
              <ul class="clear PublicStyle">
                  <li>
                      <i><img src="../../assets/image/home_task.png" /></i>
                      <h6>质检任务</h6>
                      <p>支持多种质检模式，任务可调度并支持大规模质检作业</p> 
                  </li>
                  <li>
                      <i><img src="../../assets/image/home_pingfen.png" /></i>
                      <h6>质检评分</h6>
                      <p>支持自定义评分，量化服务质量；支持复核线上处理</p> 
                  </li>
                  <li>
                      <i><img src="../../assets/image/home_report.png" /></i>
                      <h6>质检报告</h6>
                      <p>支持话务检测、内容检测、命中录音明细等类目查阅</p> 
                  </li>
                  <li>
                      <i><img src="../../assets/image/home_tongji.png" /></i>
                      <h6>质检统计</h6>
                      <p>质检统计、风险分析、业务根源分析、热点趋势分析等</p> 
                  </li>
              </ul>
          </div>
      </div>

      <div class="PublicPadding mTop20">
          <h4 class="title">应用价值</h4>
          <ul class="ulType4">
              <li>
                  <img src="../../assets/image/spe_value_pic1.png">
                  <p>充分把控通话中的<br/>对话质量</p>
              </li>
              <li>
                  <img src="../../assets/image/spe_value_pic2.png">
                  <p>规避政策风险，识<br/>别风险承诺</p>
              </li>
              <li>
                  <img src="../../assets/image/spe_value_pic3.png">
                  <p>制订话术规范，标<br/>准督导执行</p>
              </li>
              <li>
                  <img src="../../assets/image/spe_value_pic4.png">
                  <p>数据驱动营销，挖<br/>掘对话信息</p>
              </li>
          </ul>
      </div>
       <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'speechAnalysis',
  data () {
    return {
      
    }
  },
  components:{
       Popup
  },
  methods:{
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
  
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/speechAnalysis.vue